function getLoggedInState() {
    return {
        isLoggedIn: false,
    };
}

function logIn() {}
function logOut() {}
function getLoggedInUser() { return null; }

export { getLoggedInState };
export { logIn };
export { logOut };
export default {
    getLoggedInState,
    getLoggedInUser,
    logIn,
    logOut,
};
